import Layout from "Components/Layout";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import CommonClasses from "Styles/Common.module.css";
import { warningSwal } from "Util/Toast";
import { Services } from "Services";
import SkeletonLoad from "Components/TableLoad/load";
import { useForm } from "react-hook-form";
import { CSVLink, CSVDownload } from "react-csv";
import moment from "moment";
function Application() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [AllData, setAllData] = useState([]);

    const {
        register,
        handleSubmit,
        reset,

        formState: { errors },
    } = useForm();
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const getApplications = () => {
        Services.getJobApplications("GET", null, token)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(
                        response.JobApplications?.map((item) => ({
                            ...item,
                            FullPhoneNumber: `${item.CountryCode} ${item.MobileNumber}`,
                        }))
                    );
                    setAllData(
                        response.JobApplications?.map((item) => ({
                            ...item,
                            FullPhoneNumber: `${item.CountryCode} ${item.MobileNumber}`,
                        }))
                    );
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getApplications();
    }, []);
    let head = [
        "Name",
        "Email",
        "Mobile Number",
        "Role",
        "Resume",
        "Created At",
        "Message",
    ];
    console.log(AllData);
    const onSubmit = (data) => {
        const filteredDates = AllData.filter((dateStr) => {
            const date = moment(dateStr.CreatedAt);
            return (
                date.isSameOrAfter(data.FromDate, "day") &&
                date.isSameOrBefore(data.ToDate, "day")
            );
        });
        setData(filteredDates);
    };
    const clearHandler = () => {
        reset();
        setData(AllData);
    };
    const headers = [
        { label: "Name", key: "Name" },
        { label: "Email", key: "EmailID" },
        { label: "Phone Number", key: "FullPhoneNumber" },
        { label: "Role", key: "Role" },
        { label: "Applied On", key: "CreatedAt" },
        { label: "Resume", key: "Resume" },
        { label: "Message", key: "Message" },
    ];
    return (
        <Layout Active={"Applications"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Applications</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
                <div className={CommonClasses["wrapper"]}>
                    <h3>
                        Job Applications{" "}
                        <CSVLink
                            data={data} // Use modified data with combined phone number
                            headers={headers}
                            filename="applications_data.csv">
                            <button
                                style={{
                                    backgroundColor: "#0077b6",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    padding: "0.5rem",
                                }}>
                                Export
                            </button>
                        </CSVLink>
                    </h3>
                    <form
                        className={CommonClasses["Filter"]}
                        onSubmit={handleSubmit(onSubmit)}
                        style={{ padding: "0" }}>
                        <div className={CommonClasses["form_control"]}>
                            <label htmlFor="">From Date</label>
                            <input
                                style={{ textTransform: "uppercase" }}
                                {...register("FromDate", { required: false })}
                                type="date"
                            />
                        </div>
                        <div className={CommonClasses["form_control"]}>
                            <label htmlFor="">To Date</label>
                            <input
                                style={{ textTransform: "uppercase" }}
                                {...register("ToDate", { required: false })}
                                type="date"
                            />
                        </div>

                        <button>Submit</button>
                        <button
                            style={{
                                border: "1px solid #0077b6",
                                backgroundColor: "white",
                                color: "#0077b6",
                            }}
                            type="button"
                            onClick={clearHandler}>
                            Clear
                        </button>
                    </form>
                    {loading ? (
                        <SkeletonLoad TableHead={head} />
                    ) : (
                        <>
                            <div className={CommonClasses["Table"]}>
                                <table>
                                    <thead>
                                        <tr>
                                            {head.map((item, index) => (
                                                <th key={index}>{item}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 ? (
                                            data.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.Name}</td>
                                                    <td>{item.EmailID}</td>
                                                    <td>
                                                        {item?.CountryCode}{" "}
                                                        {item.MobileNumber}
                                                    </td>
                                                    <td>{item.Role}</td>
                                                    <td>
                                                        <a
                                                            href={item.Resume}
                                                            target="_blank">
                                                            Link
                                                        </a>
                                                    </td>
                                                    <td>
                                                        {moment(
                                                            item.CreatedAt
                                                        ).format("DD-MM-YYYY")}
                                                    </td>
                                                    <td>{item.Message}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={head.length}>
                                                    No Applications Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Application;
